import { ChangeEvent } from "react";

import { Icon, SearchSVG, type SvgComponentType } from "@newsela/angelou";

import { expandedSearchBarVisibilityCss } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SearchMenu/ExpandedSearchInput/ExpandedSearchInput.styles";
import { SEARCH_MENU_ID } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SearchMenu/SearchMenu";
import {
  absoluteSearchIconCss,
  inputFieldCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/SearchMenu/SearchMenu.styles";

const MAX_CHARS = 400;

const ExpandedSearchInput = ({
  inputValue,
  onFocus,
  onChange,
  onKeyDown,
}: IExpandedSearchInput) => {
  return (
    <div css={expandedSearchBarVisibilityCss}>
      <Icon
        SvgComponent={SearchSVG as SvgComponentType}
        __cssFor={absoluteSearchIconCss}
      />
      <input
        tabIndex={0}
        className={SEARCH_MENU_ID}
        data-testid="expanded-search-input"
        data-qa-selector="global-nav-search"
        autoComplete="off"
        value={inputValue}
        onFocus={onFocus}
        onClick={onFocus}
        onChange={onChange}
        maxLength={MAX_CHARS}
        // @ts-expect-error typescript is complaining about the KeyboardEvent
        onKeyDown={onKeyDown}
        css={inputFieldCss}
        placeholder="Search for texts and more"
      />
    </div>
  );
};

interface IExpandedSearchInput {
  inputValue: string;
  onFocus: () => void;
  showSuggestions: boolean;
  onKeyDown: (event: KeyboardEvent) => void;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

ExpandedSearchInput.displayName = "ExpandedSearchInput";
export { ExpandedSearchInput };
